export function setToken(type: string, token: string) {
    localStorage.setItem(type, token);
  }
  
  export function getToken(type: string) {
    return localStorage.getItem(type);
  }
  
  export function removeToken(type: string) {
    return localStorage.removeItem(type);
  }
  
  export function prepareQuery(values: { [key: string]: any }) {
    let query = "";
    let firstVal = true;
    if (values && values !== undefined) {
      Object.keys(values).forEach((item) => {
        if (values[item] !== "") {
          query += `${firstVal ? "?" : "&"}${item}=${values[item]}`;
          firstVal = false;
        }
      });
    }
    return query;
  }
  
  export function prepareTableQuery(values: { [key: string]: any }) {
    let query = "";
    let firstVal = true;
    if (values && values !== undefined) {
      Object.keys(values).forEach((item) => {
        if (values[item] !== "") {
          if (Array.isArray(values[item])) {
            values[item].forEach((element: { [key: string]: any }, idx: number) => {
              Object.keys(element).forEach((elem) => {
                query += `${firstVal ? "?" : "&"}${item}[${idx}].${elem}=${element[elem]}`;
                firstVal = false;
              });
            });
          } else {
            query += `${firstVal ? "?" : "&"}${item}=${values[item]}`;
            firstVal = false;
          }
        }
      });
    }
    return query;
  }
  